import ForceGraph from '../src/force-graph.js';
import brainInstanceInject from './brain-instance-inject.js';
import brainOptionInject from './brain-option-inject.js';
import brainForceOption from './brain-force-option.js';
import brainRenderOption from './brain-render-option.js';

let baseHeight = 1080;
let curHeight = window.innerHeight;
let scale = curHeight / baseHeight;
if (scale < 1) {
    scale = 1;
}
let zoom = 1;
if (scale > 1) {
    zoom = 1;
} else {
    zoom = 0.75;
}
console.log('图谱缩放：', scale);
// TODO 最低的scale是1
if (window._screenType === '2160') {
    if ($qsObj && $qsObj.scale !== 'false') {
        scale *= 1.25;
    }
}
let ForceGraphBrain = (customOptions) => {
    let defaultOptions = {
        showHalo: false,
        key: 'id',
        zoom: zoom,
        scale: scale,
    };
    Object.assign(defaultOptions, customOptions);
    let graph = new ForceGraph(defaultOptions);
    brainOptionInject(graph); // 注入一些option上的配置的方法
    brainInstanceInject(graph); // 注入自定义的一些实例方法
    graph.dataProcess(); // 前置处理数据

    graph.force(brainForceOption(graph));
    graph.render(brainRenderOption(graph));
    graph.start();

    return graph;
};

export default ForceGraphBrain;


















